import React from 'react';
import { IContent } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './AdvantagesBlock.scss';

// @ts-ignore
import Reveal from "react-reveal/Reveal";

import CONFIG from "../../../config";
import Title from "../../Elements/Title/Title";
import Advantage from "../../Elements/Advantage/Advantage";
import { sendEvent } from "../../../utils";

interface IAdvantagesBlockProps {
  context?: IContent;
}

const AdvantagesBlock = ({ context }: IAdvantagesBlockProps) => {
  const { advantages } = context;
  return (
    <Reveal onReveal={() => sendEvent("compare welcome - tab displayed - scroll")}>
      <div className="block-advantages">
        <div className="content">
          <Title headline={advantages.title.headline} baseline={advantages.title.baseline} color="#E9E2CF" />
          <ul className="advantages">
            {advantages.list.map((advantage: any, index: number) => (
              <Advantage key={index} info={CONFIG.isUPC ? advantage.upc : advantage.web} />
            ))}
          </ul>
        </div>
      </div>
    </Reveal>
  );
};

export default withContent(AdvantagesBlock);
